import React from 'react'
import Layout from '../../Layout/Layout'

const Data_Sovereignty  = () => {
  return (
     <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>Data Sovereignty and Talent Sovereignty</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The continental framework on Data Sovereignty and Talent Sovereignty was 
                        strategically designed to safeguard Africa's critical data assets while actively
                         strengthening its indigenous Artificial Intelligence (AI) capabilities .
                          This dual-focused approach recognizes that control over national and regional 
                          data is paramount to ensuring equitable technological development and
                           preventing digital colonialism.
</p>

                <p className='light'>The concept of Data Sovereignty addresses the legal and physical
                     control over data collected within Africa, ensuring that this valuable resource 
                     is leveraged primarily for the continent's benefit and innovation. Concurrently, 
                     Talent Sovereignty focuses on building robust local talent pipelines and providing 
                     the necessary skills and infrastructure to create African-led AI solutions. 
                     This prevents over-reliance on external expertise and fosters self-sustaining
                      innovation ecosystems.</p>
               </div>

                <div className='uk-width-1-2@s'>
                <p className='light'>A core contribution of this policy framework is its active
                     role in supporting the effective implementation of the African Union (AU) AI
                      Strategy across member states. By providing a practical and policy-ready
                       document, it helps translate high-level AU strategic goals into actionable
                        national and regional directives. This alignment ensures a unified and
                         coordinated approach to AI governance and development across the continent.</p>

        

                        <p className='light'><span className='uk-text-bold'>Contribution: </span> Supporting African Union AI Strategy implementation in member states.</p>
                         <p className='light'>DOI: https://doi.org/10.5281/zenodo.16877245</p>
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default Data_Sovereignty 